import { paymentCommissionActions } from 'src/store/api/paymentCommission/actions';
import { IInitState } from 'src/store/api/paymentCommission/types';
import { createReducer } from '@reduxjs/toolkit';

const initialState: IInitState = {
  commissions: {},
  commission: {},
};

export const paymentCommissionReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(paymentCommissionActions.getPaymentCommissions.fulfilled, (state, action) => {
      if (!action.payload) {
        return;
      }

      state.commissions = action.payload;
    })
    .addCase(paymentCommissionActions.getPaymentCommission.fulfilled, (state, action) => {
      if (!action.payload) {
        return;
      }

      state.commission = action.payload;
    })
    .addCase(paymentCommissionActions.togglePaymentCommission.fulfilled, (state, action) => {
      if (!state.commissions.content || !action.payload) {
        return;
      }
      const newCommission = action.payload;

      const newCommissions = state.commissions.content.map((commission) => {
        if (commission.id === newCommission.id) {
          return newCommission;
        }
        return commission;
      });

      state.commissions.content = newCommissions;
    }),
);
